import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

const TRANSACTION_STATUS = {
  MONEY_PROCESSED: 230,
  MARKED_AS_SOLD: 452,
  COMPLETED_MANUALLY: 455,
}

type Props = {
  transactionStatus: number | null | undefined
  isSellerBusiness: boolean
  isViewingOwnItem: boolean
}

export const useSellerProtectionVisibility = ({
  transactionStatus,
  isSellerBusiness,
  isViewingOwnItem,
}: Props) => {
  const saleIsSafePolicyInConversationScreenAbTest = useAbTest(
    'sale_is_safe_policy_in_conversation_screen',
  )
  const isSaleIsSafePolicyInConversationScreenAbTestEnabled =
    saleIsSafePolicyInConversationScreenAbTest?.variant === 'on'

  const isTransactionPostOrder =
    !!transactionStatus &&
    transactionStatus >= TRANSACTION_STATUS.MONEY_PROCESSED &&
    transactionStatus !== TRANSACTION_STATUS.MARKED_AS_SOLD &&
    transactionStatus !== TRANSACTION_STATUS.COMPLETED_MANUALLY

  const isSellerProtectionVisible =
    !!transactionStatus && isTransactionPostOrder && !isSellerBusiness && isViewingOwnItem

  useTrackAbTest(saleIsSafePolicyInConversationScreenAbTest, isSellerProtectionVisible)

  return isSellerProtectionVisible && isSaleIsSafePolicyInConversationScreenAbTestEnabled
}
